import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { IMAGE_DETECTION_EXAMPLE, SPONSOR_VALUE } from "../keys";

const useSponsorImageDetectionExample = (sponsorObjectId) => {
  const tenant = useSelector((state) => state.auth.tenant);
  return useQuery({
    queryKey: [SPONSOR_VALUE, IMAGE_DETECTION_EXAMPLE, tenant.id, sponsorObjectId],
    queryFn: () => ApiService.getSponsorImageDetectionExample(sponsorObjectId),
    select: (data) => data.data,
    placeholderData: { data: [] },
  });
};
export default useSponsorImageDetectionExample;
